import type { ArtistDirectorySearchState } from "@/features/feature-page/artist-directory-query";
import { pickEnum, pickNumber, pickString } from "@/lib/search-params";

const DIRECTORY_SORTS = [
  "relevance",
  "prominence",
  "name",
  "name-desc",
  "begin-asc",
  "begin-desc",
] as const;

export function parseArtistDirectorySearch(
  raw: Record<string, unknown>,
): ArtistDirectorySearchState {
  const page = pickNumber(raw.page);
  return {
    q: pickString(raw.q),
    genre: pickString(raw.genre),
    style: pickString(raw.style),
    country: pickString(raw.country),
    decade: pickNumber(raw.decade),
    sort: pickEnum(raw.sort, DIRECTORY_SORTS),
    page: page && page > 1 ? Math.floor(page) : undefined,
  };
}
